module.exports = __webpack_public_path__ + "img/wa_wiz_side.38c3d940.jpg";